/**
 * SOLE cart-drawer open trigger. Any element with [data-sole-cart-open] (e.g. the header
 * cart icon) opens the drawer; no-JS falls back to the element's href (/cart).
 */
(function () {
  if (window.__soleCartOpenWired) return;
  window.__soleCartOpenWired = true;
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sole-cart-open]');
    if (!trigger) return;
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || typeof drawer.open !== 'function') return; // let the href fallback happen
    e.preventDefault();
    drawer.open();
  });
})();
